import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

import { OccConfig } from '@spartacus/core';

import { IDocument } from '@seb/web-design-system/documents';

import { BynderDocument, InstructionsForUse } from '../models';
import { RepairabilityDocsOrder } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class DocumentMapper {
  constructor(private occConfig: OccConfig, private translateService: TranslateService) {}

  getInstructionsForUseToDocument(instructionsForUses: InstructionsForUse[]): IDocument[] {
    const documents: IDocument[] = [];

    instructionsForUses
      .filter((ifu) => !!ifu.externalDocumentURL)
      .forEach((ifu) => {
        documents.push({
          title: ifu.name ? ifu.name : this.translateService.instant(`ifuTitles.${ifu.documentType}`),
          link: this.normalizeUrl(ifu.externalDocumentURL)
        });
      });

    return documents;
  }

  getBynderDocumentToSortedDocuments(bynderDocuments: BynderDocument[]): IDocument[] {
    const repairabilityDocsOrder = RepairabilityDocsOrder.split(',');
    return bynderDocuments
      .filter((bynderDocument) => !!bynderDocument)
      .sort((doc1, doc2) => {
        return (
          repairabilityDocsOrder.indexOf(doc1.property_assettype[0]) -
          repairabilityDocsOrder.indexOf(doc2.property_assettype[0])
        );
      })
      .map((bynderDocument) => ({
        title: bynderDocument.description,
        link: this.normalizeUrl(bynderDocument.original)
      }));
  }

  normalizeUrl(url: string): string {
    if (new RegExp(/^(http|\/\/)/i).test(url)) {
      return url;
    }
    return (this.occConfig.backend?.occ?.baseUrl || '') + url;
  }
}
